module.exports = __webpack_public_path__ + "img/Icon_Information.ea1882d1.svg";